import { formatQuantity } from '../../format-quantity.js';
/** SF-BR-20: what Review Changes and the save say when a line is added or raised past what can be promised; a null `available` leaves the figure out. */
export function lineChangeAtpRefusalMessage({ product, available, entered, }) {
    const rest = `(you entered ${formatQuantity(entered)}). Lower the quantity, or create a new order for the rest.`;
    if (available === null)
        return `Not enough available for ${product} ${rest}`;
    return `Only ${formatQuantity(available)} available for ${product} ${rest}`;
}
//# sourceMappingURL=line-change-atp-refusal.js.map